{
  "Earlier": "それ以前",
  "noAnnouncements": "予定されてるメンテナンスアクティビティや、修正される製品の問題についての情報を受け取ります。",
  "noAnnouncementsTitle": "お知らせはここに表示されます"
}
